export class DateTimeRangeModel {
  constructor(public fromDateTime: Date, public toDateTime: Date) {}
}
